<template>
  <footer class="footer">
    <div class="stripe">
      <to-top-button class="top"></to-top-button>
    </div>
    <div :class="{ 'navigation flex': !isStudentOnlyUser }" v-show="!isStudentOnlyUser" >
      <div class="col-1"></div>
      <div class="col-3">
        <router-link :to="{name: 'student'}">
          <img alt='logo' src="../../assets/images/39-lrn-spt-logo-190.svg"/>
        </router-link>
      </div>
      <div class="col-7 mr-1 legal-1">
        <p>Copyright © {{ copyrightYear }} by Lerner Publishing Group, Inc. Lerner™ Sports and Lerner™ Sports logo are all property of Lerner Publishing Group, Inc. and may not be reproduced or repurposed without the written permission of Lerner Publishing Group, Inc. All Rights Reserved.</p>
      </div>
      <div class="col-1"></div>
    </div>
  </footer>
</template>

<script>
  import ToTopButton from '@/component/ToTopButton';
  import { mapGetters } from 'vuex';

  export default {
    name: 'StudentFooter',

    components: {
      ToTopButton
    },

    data: function() {
      return {
        copyrightYear: new Date().getFullYear(),
      };
    },

    computed: {
      ...mapGetters(['isStudentOnlyUser']),
    },
  }
</script>

<style lang="scss" scoped>
  .footer {
    @apply border-t-6 border-f1-b bg-f1-a border-solid relative mt-8 py-6;

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 16px;
      left: 0;
      top: -22px;
      background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.1) 100%);
    }

    .top {
      width: 40px;
      height: 40px;
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
    }

    p {
      @apply text-f1-d m-0;
    }
  }
</style>
